import { Gizmo } from '../gizmos';
import {
  AnnexFormBinder,
  BooleanFieldBinder,
  DateFieldBinder,
  FileFieldBinder,
  IdOcrFieldBinder,
  LocationFieldBinder,
  MultimediaFieldBinder,
  NumberFieldBinder,
  PhoneFieldBinder,
  RateFieldBinder,
  SelectFieldBinder,
  SignatureFieldBinder,
  TextFieldBinder,
} from './daq';
import { ChartBinder, IndicatorBinder } from './analytic';
import { ButtonBinder, IndexBinder } from './visual';
import { RowBinder, SectionBinder } from './container';
import { FolioBinder } from './display';

/**
 * In case there's a binder for that given Gizmo's type we're going to return the binder
 *
 * @param {Gizmo} gizmo reference to Gizmo's instance
 * @returns {any} binder instance in case it exists
 */
function binderInit(gizmo: Gizmo): any | undefined {
  let binder: any | undefined;

  switch (gizmo.getConfig().type) {
    // DAQ
    case 'text_field':
      binder = new TextFieldBinder(gizmo);
      break;
    case 'number_field':
      binder = new NumberFieldBinder(gizmo);
      break;
    case 'select_field':
      binder = new SelectFieldBinder(gizmo);
      break;
    case 'file_field':
      binder = new FileFieldBinder(gizmo);
      break;
    case 'date_field':
      binder = new DateFieldBinder(gizmo);
      break;
    case 'phone_field':
      binder = new PhoneFieldBinder(gizmo);
      break;
    case 'annex_form':
      binder = new AnnexFormBinder(gizmo);
      break;
    case 'rate_field':
      binder = new RateFieldBinder(gizmo);
      break;
    case 'boolean_field':
      binder = new BooleanFieldBinder(gizmo);
      break;
    case 'signature_field':
      binder = new SignatureFieldBinder(gizmo);
      break;
    case 'multimedia_field':
      binder = new MultimediaFieldBinder(gizmo);
      break;
    case 'id_ocr_field':
      binder = new IdOcrFieldBinder(gizmo);
      break;
    case 'location_field':
      binder = new LocationFieldBinder(gizmo);
      break;
    // VISUAL
    case 'button':
      binder = new ButtonBinder(gizmo);
      break;
    case 'index':
      binder = new IndexBinder(gizmo);
      break;
    // ANALYTIC
    case 'chart':
      binder = new ChartBinder(gizmo);
      break;
    case 'indicator':
      binder = new IndicatorBinder(gizmo);
      break;
    // CONTAINER
    case 'row':
      binder = new RowBinder(gizmo);
      break;
    case 'section':
      binder = new SectionBinder(gizmo);
      break;
    // DISPLAY
    case 'folio':
      binder = new FolioBinder(gizmo);
      break;
  }

  return binder;
}

export default binderInit;
